import React from 'react';
import styled, { css } from 'styled-components';

export const StyledFormItem = styled.div`
  width: 100%;
  padding: 0 10px;
  margin-bottom: 25px;

  ${props => props.col && css`
    width: ${(props.col / 12) * 100}%;
  `}
`;

const FormItem = ({ col, children }) => {
  return (
    <StyledFormItem col={col}>
      {children}
    </StyledFormItem>
  );
};

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/FormItem.jsx